export default "__VITE_ASSET__29145cf4__"